<template>
    <div>
        <div class="container-fluid position-relative bg-BAT">
            <loading v-if="loading == 1" ></loading>
            <div class="container py-3 mb-2">
                <div class="breadcrumbs-retos py-2 text-bat">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt="" />
                    </a>
                    <span v-if="categoryName === null" class="color-active-miga link text-title-bat"><strong>Catálogo</strong></span>
                    <a v-if="categoryName !== null" class="link cursor-pointer text-title-bat" href="/catalogo" >Catálogo /</a>
                    <span v-if="categoryName !== null" class="color-active-miga text-title-bat"><strong>{{ categoryName }}</strong></span>
                </div>
                <div class="my-2">
                    <a class="text-title-bat text-dark" href="/home-bat">
                        <img src="/img/icons/regresar.svg" alt="icon">
                    </a>
                </div>
                <div class="row mt-4 mb-4">
                    <div class="col-12 col-md-6 col-lg-7">
                        <h5 class="text-indigo-darkness text-title-bat">
                            Nuestro catálogo
                        </h5>
                    </div>
                    <div class="col-12 col-md-6 col-lg-5">
                        <div>
                            <div class="border-1 rounded-5 border border-gray-search bg-white d-flex flex-row px-3 py-2 justify-content-between">
                                <input class="border-0 w-100 bg-white text-bat text-color-gray-search fs-6 py-1" type="text" placeholder="¿Qué producto estás buscando?" @keydown.enter="searchProducts" v-model="productSearch">
                                <img class="cursor-pointer" src="/img-version2/icons/lupa.svg" alt="" @click="searchProducts">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Categorias -->
                <div class="row my-3 my-md-2">
                    <slick v-if="categoryProducts && categoryProducts.length" ref="slick" :options="slickOptionsCategories" class="p-2 slick-vue mb-3 div-con-filtro ">
                        <div v-for="categorias in categoryProducts" :id="categorias.id + '-categorias-canjea'" :title="categorias.name" class="col-1 d-flex justify-content-center flex-column cursor-pointer"  @click="categorias.id_netcommerce !== null ?categorySelect(categorias.id_netcommerce) : categoriadestacada()">
                            <div class="d-flex shadow justify-content-center mx-2 my-2 px-2 py-3 rounded-3" :class="{'bg-white' : !isStaffUser || categorias.id_netcommerce !== null,'border border-catalog border-1': categorySelected === categorias.id_netcommerce,'category-titila': categorias.id_netcommerce === null && isStaffUser}">
                                <img class="img-category-width" :src="categorias.icon" :alt="categorias.name">
                            </div>
                            <span class="text-center fs-text-category text-bat text-indigo-darkness lh-1 mt-2">
                                {{ categorias.name }}
                            </span>
                        </div>
                    </slick>
                </div>
                <!-- Filtros y ordenamientos -->
                <div class="row mt-4 mt-md-4 mb-2 mb-md-4 justify-content-between">
                    <new-banners v-if="isStaffUser && show_banners === true" location = 'redeem'></new-banners>
                    <div class="col-6 col-md-10 d-flex flex-column flex-md-row justify-content-start align-items-center flex-wrap">
                        <el-button class="cursor-pointer bg-transparent text-bat border-0" @click="orderPointsModal = true">
                            <span>
                                Filtrar por
                            </span>
                            <img class="ms-2" src="/img/icons/filter-points.svg" alt="filter-points">
                        </el-button>
                        <div v-if="selectedPointRanges && selectedPointRanges.length > 0" class="d-flex flex-row ms-2 d-none d-md-block mt-3" v-for="(range, index) in selectedPointRanges" :key="index">
                            <span class="bg-secondary bg-opacity-10 text-dark fs-6 rounded-5 text-bat py-2 px-2 mb-2">
                                {{ range.label }}
                                <span class="cursor-pointer text-title-bat" @click="() => removePointRangeFilter(index)">
                                    <img src="/img/icons/button_close.svg" alt="close_button">
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="col-6 col-md-2">
                        <el-button class="cursor-pointer float-end bg-transparent text-bat border-0" @click="orderModal = true">
                            <span>
                                Ordenar por
                            </span>
                            <img class="ms-2" src="/img/icons/filter-order.svg" alt="filter-order">
                        </el-button>
                    </div>
                </div>
                <div class="d-block d-md-none">
                    <div v-if="selectedPointRanges && selectedPointRanges.length > 0" class="d-flex flex-row ms-2" v-for="(range, index) in selectedPointRanges" :key="index">
                        <span class="bg-secondary bg-opacity-10 text-dark fs-6 rounded-5 text-bat py-2 px-2 mb-2">
                            {{ range.label }}
                            <span class="cursor-pointer text-title-bat" @click="() => removePointRangeFilter(index)">
                                <img src="/img/icons/button_close.svg" alt="close_button">
                            </span>
                        </span>
                    </div>
                </div>
                <!-- Modal para filtro de puntos -->
                <el-dialog
                :visible.sync="orderPointsModal"
                :width="getWidth()"
                class="filterDialogCatalog"
                >
                    <el-radio-group class="d-flex flex-column text-bat" v-model="orderFilterPointsOption">
                        <el-radio class="mb-2" :label="1">De 1 - 100 pts</el-radio>
                        <el-radio class="mb-2" :label="2">De 101 - 400 pts</el-radio>
                        <el-radio class="mb-2" :label="3">De 401 - 800 pts</el-radio>
                        <el-radio class="mb-2" :label="4">801 - 1000 pts</el-radio>
                        <el-radio class="mb-2" :label="5">Mas de 1000 pts</el-radio>
                        <el-radio class="mb-2" :label="6">Todos los rangos</el-radio>
                    </el-radio-group>
                    <span slot="footer" class="dialog-footer d-flex justify-content-center">
                        <el-button class="btn btnBlue border-0 text-title-bat" type="primary" @click="() => selectPointRange(orderFilterPointsOption)">Aplicar</el-button>
                    </span>
                </el-dialog>
                <!-- Modal para filtro de ordenamiento -->
                <el-dialog
                :visible.sync="orderModal"
                :width="getWidth()"
                class="rounded-4 filterDialogCatalog"
                >
                    <el-radio-group class="d-flex flex-column text-bat" v-model="orderFilterOption">
                        <el-radio class="mb-2" :label="2">De menor a mayor (PTS)</el-radio>
                        <el-radio class="mb-2" :label="3">De mayor a menor (PTS)</el-radio>
                        <el-radio class="mb-2" :label="1">De la A a la Z</el-radio>
                    </el-radio-group>
                    <span slot="footer" class="dialog-footer d-flex justify-content-center">
                        <el-button class="btn btnBlue border-0 text-title-bat" type="primary" @click="() => changeOrderFilter(orderFilterOption)" >Aplicar</el-button>
                    </span>
                </el-dialog>
                <!-- Listado de productos -->
                <div v-if="currentPageProducts && currentPageProducts.length">
                    <div class="row justify-content-around">
                        <div v-for="productos in currentPageProducts" class="px-2 px-mg-2 col-6 col-sm-3 col-lg-2 mb-5">
                            <div class="cursor-pointer mx-1 mx-md-1 mx-lg-1 d-flex flex-column justify-content-between px-2 py-2 shadow-sm rounded-2">
                                <a :id="productos.id + '-detalle-canjea'" :title="productos.name" class="text-product-card" :href="'/catalog-category/' + productos.ID + '/product-detail/' + productos.guid">
                                    <div class="p-1">
                                        <div class="divImg bg-white shadow-sm rounded-4 position-relative d-flex justify-content-center align-items-center mb-2 w-100 ">
                                            <!-- Contenedor de etiquetas -->
                                            <div class="position-absolute top-0 start-0 d-flex">
                                                <div v-if="isStaffUser && productos.is_top_redemption" class="rounded-start-1 bg-orange text-white p-1">
                                                    <p class="mb-0 text-nowrap">
                                                        <small>Top redimidos</small>
                                                    </p>
                                                </div>
                                                <div v-else class="rounded-start-1 bg-lighterblue p-1">
                                                    <p class="mb-0 text-bat text-dark text-nowrap">
                                                        <small>{{ productos.category }}</small>
                                                    </p>
                                                </div>
                                            </div>
                                            <img :src="productos.image == null || productos.image == '' ? '/img/default_image.png' :  url_media + productos.image.slice(1,productos.image.length)" class="w-100 h-100 rounded-4 img-product-width">
                                        </div>
                                    </div>
                                    <div>
                                        <p class="fs-6 mb-1 text-title-bat">
                                            <b class="fs-6">
                                                {{ productos.value_points }}
                                            </b>
                                            Puntos
                                        </p>
                                        <p class="text-bat fs-6 fw-bold text-bat text-indigo-darkness texto-truck-descript mb-2">
                                            {{ productos.name }}
                                        </p>
                                    </div>
                                    <div class="text-center d-flex justify-content-center">
                                        <button type="button" class="w-100 mx-1 btn btnBlue text-title-bat rounded-3">
                                            Ver detalle
                                        </button>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- Paginación -->
                    <div class="d-flex align-items-center justify-content-center">
                        <button @click="prevPage" :disabled="pageSelected === 1" class="bg-transparent border-0"> < </button>
                        <div class="text-bat">
                            <span v-if="visiblePages[0] > 1">...</span>
                            <span v-for="page in visiblePages" :key="page" @click="goToPage(page)" class="mx-3 mx-md-4 cursor-pointer" :class="{ 'text-title-bat text-orange': page === pageSelected }">{{ page }}</span>
                            <span v-if="visiblePages[visiblePages.length - 1] < pagesTotals">...</span>
                        </div>
                        <button @click="nextPage" :disabled="pageSelected === pagesTotals" class="bg-transparent border-0"> > </button>
                    </div>
                </div>
                <div v-else>
                    <h2>
                        No hay productos. Selecciona otra categoria o filtro.
                    </h2>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import Slick from 'vue-slick';
    import 'slick-carousel/slick/slick.css';
    export default {
        components: { Slick },
        props: {
            url_media: {
                default: '',
            },
            category_selected: {
                default: null,
            },
            search: {
                default: '',
            },
            client_segment: {
                type: Number,
                default: null,
            },
            staff_segments: {
                default: [],
            },
        },
        data (){
            return {
                loading: 0,
                category_data: [],
                products: [],
                pagination: null,
                searchKey: '',
                searching: false,
                findProducts: [],
                findPagination: null,
                most_recent_products: [],
                selectedCategory: null,
                show_banners: false,

                program_id: null,
                selectedFilter: [0,1000000],
                pointRange: '0,1000000',
                productOrdering: 'smallToBig',
                most_recent_products_filtered: [],

                products_filtered: [],
                products_filtered_per_page: 20,
                searched_products_filtered_per_page: 20,
                paginated_data: [],
                paginated_searched_products_data: [],
                current_page: 1,

                searched_products: [],
                searched_products_filtered: [],

                categoryName: null,
                slickOptionsProducts: Object,
                slickOptionsCategories: Object,
                currentPage: 1,

                categoryProducts: null,
                dataProducts: null,
                dataProductsOrder: null,
                totalPoints: null,
                productSearch: null,
                productsForPage: 18,
                pageSelected: 1,
                categorySelected: 0,
                orderPointsModal: false,
                orderModal: false,
                orderFilterPointsOption: null,
                orderFilterOption: 2,
                availablePointRanges: [
                    { label: 'De 1 - 100 pts', value: 1, min: 1, max: 100 },
                    { label: 'De 101 - 400 pts', value: 2, min: 101, max: 400 },
                    { label: 'De 401 - 800 pts', value: 3, min: 401, max: 800 },
                    { label: 'De 801 - 1000 pts', value: 4, min: 801, max: 1000 },
                    { label: 'Más de 1000 pts', value: 5, min: 1001, max: Infinity },
                    { label: 'Todos los rangos', value: 6, min: 1, max: Infinity },
                ],
                selectedPointRanges: [],
                alreadyAttemptedFallback: false,
                allProducts: [],
                getWidth() {
                    if (this.$mq === 'sm') {
                        return '95%';
                    } else if (this.$mq === 'md') {
                        return '35%';
                    } else if (this.$mq === 'lg') {
                        return '30%';
                    } else {
                        return '20%';
                    }
                }
            }
        },
        mounted() {
            this.searchKey = this.search;
            this.slickOptionsProps();
        },
        created() {
            this.getCatalog();
            const urlParams = new URLSearchParams(window.location.search);
            const categoryParam = urlParams.get('category');
            if (categoryParam !== null && !isNaN(categoryParam)) {
                this.categorySelected = parseInt(categoryParam);
            } else if(categoryParam === 'outStanding'){
                this.updateURL(1);
                this.categorySelected = null;
            }
            this.pageSelected = parseInt(urlParams.get('page')) || 1;
            this.productSearch = urlParams.get('search_text') || '';
            if(this.categorySelected > 0 ){
                this.categorySelect(this.categorySelected);
            }else if(this.categorySelected == null){
                this.categoriadestacada(this.categorySelected);
            }else if(this.productSearch !== '') {
                this.searchProducts();
            }
        },
        watch: {
            searchKey: function() {
                if (this.searchKey !== '') {
                    this.searching = true;
                    this.searchProducts2(this.searchKey)
                } else {
                    this.searching = false;
                }
            },
        },
        computed: {
            mq() {
                if(this.$mq === 'sm'){
                    return 8;
                }else{
                    return 18;
                }
            },
            pagesTotals() {
                return Math.ceil(this.dataProducts.length / this.productsForPage);
            },
            currentPageProducts() {
                if (this.dataProducts !== null) {
                    this.productsForPage = this.mq;
                    const startIndex = (this.pageSelected - 1) * this.productsForPage;
                    const endIndex = startIndex + this.productsForPage;
                    // Verifica si this.dataProducts no es null antes de llamar a slice
                    return this.dataProducts.slice(startIndex, endIndex);
                } else {
                    // En caso de que this.dataProducts sea null, devuelve un valor predeterminado o maneja el caso de error según sea necesario
                    return []; // o cualquier otro valor predeterminado que sea adecuado para tu caso
                }
            },
            numberOfPages() {
            const pages = [];
                for (let i = 1; i <= this.pagesTotals; i++) {
                    pages.push(i);
                }
                return pages;
            },
            initialPage() {
                if (this.pagesTotals <= 10) {
                    return 1;
                } else if (this.pageSelected <= 5) {
                    return 1;
                } else if (this.pageSelected >= this.pagesTotals - 4) {
                    return this.pagesTotals - 9;
                } else {
                    return this.pageSelected - 4;
                }
            },
            lastPage() {
                if (this.pagesTotals <= 10) {
                    return this.pagesTotals;
                } else if (this.pageSelected <= 5) {
                    return 10;
                } else if (this.pageSelected >= this.pagesTotals - 4) {
                    return this.pagesTotals;
                } else {
                    return this.pageSelected + 5;
                }
            },
            visiblePages() {
                let startPage = Math.max(1, this.pageSelected - 4);
                let endPage = Math.min(startPage + 4, this.pagesTotals); // 4 páginas a la izquierda, 4 a la derecha y la actual
                if (endPage - startPage < 4) {
                    startPage = Math.max(1, endPage - 4);
                }
                return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
            },
            isStaffUser() {
                return this.staff_segments.includes(this.client_segment);
            },
        },
        methods: {
            resetAll() {
                this.selectedCategory = null
                this.searching = false
                this.searchKey = ''

                this.pointRange = '0,1000000'
                this.changeSelectedFilter()

                this.productOrdering = 'smallToBig'
                this.changeProductOrdering(this.productOrdering)
            },
            totalPages() {
                if (this.searching === false) {
                    return Math.ceil(this.products_filtered.length / this.products_filtered_per_page)
                } else {
                    return Math.ceil(this.searched_products_filtered.length / this.searched_products_filtered_per_page)
                }
            },
            getPageData(page) {
                if (this.searching === true) {
                    this.paginated_searched_products_data = [];
                    let start = (page * this.searched_products_filtered_per_page) - this.searched_products_filtered_per_page;
                    let end = (page * this.searched_products_filtered_per_page);
                    this.paginated_searched_products_data = this.searched_products_filtered.slice(start, end);
                    this.current_page = page
                } else {
                    this.paginated_data = [];
                    let start = (page * this.products_filtered_per_page) - this.products_filtered_per_page;
                    let end = (page * this.products_filtered_per_page);
                    this.paginated_data = this.products_filtered.slice(start, end);
                    this.current_page = page
                }
            },
            getPreviousPage() {
                if(this.current_page > 1) {
                    this.current_page--;
                }
                this.getPageData(this.current_page);
            },
            getNextPage() {
                if(this.current_page < this.totalPages()) {
                    this.current_page++;
                }
                this.getPageData(this.current_page);
            },
            changeSelectedFilter(){
                this.selectedFilter[0] = parseInt(this.pointRange.split(",")[0]);
                this.selectedFilter[1] = parseInt(this.pointRange.split(",")[1]);

                if (this.searching === true) {
                    this.searched_products_filtered = this.searched_products.filter((item) => (item.VALUE_POINTS >= this.selectedFilter[0] && item.VALUE_POINTS <= this.selectedFilter[1]));
                } else {
                    this.most_recent_products_filtered = [];
                    for(let i in this.most_recent_products) {
                        if(this.most_recent_products[i].VALUE_POINTS >= this.selectedFilter[0] && this.most_recent_products[i].VALUE_POINTS <= this.selectedFilter[1]) {
                            this.most_recent_products_filtered.push(this.most_recent_products[i]);
                        }
                    }

                    if (this.selectedCategory === null) {
                        this.products_filtered = this.products.filter((item) => (item.VALUE_POINTS >= this.selectedFilter[0] && item.VALUE_POINTS <= this.selectedFilter[1]));
                    } else {
                        this.products_filtered = this.products.filter((item) => (item.VALUE_POINTS >= this.selectedFilter[0] && item.VALUE_POINTS <= this.selectedFilter[1] && item.CATEGORY_ID == this.selectedCategory));
                    }
                }

                this.getPageData(1)
            },
            changeProductOrdering(productOrdering) {
                let array_most_recent_products = []
                let array_products = []
                let array_searched_products = []

                for(let i in this.most_recent_products) {
                    array_most_recent_products.push(this.most_recent_products [i]);
                }

                for(let i in this.products) {
                    array_products.push(this.products [i]);
                }

                for(let i in this.searched_products) {
                    array_searched_products.push(this.searched_products [i]);
                }

                if(productOrdering == 'smallToBig') {
                    this.most_recent_products = array_most_recent_products.sort(function(a, b) {return a.VALUE_POINTS - b.VALUE_POINTS});
                    this.products = array_products.sort(function(a, b) {return a.VALUE_POINTS - b.VALUE_POINTS});
                    this.searched_products = array_searched_products.sort(function(a, b) {return a.VALUE_POINTS - b.VALUE_POINTS});
                } else {
                    this.most_recent_products = array_most_recent_products.sort(function(a, b) {return b.VALUE_POINTS - a.VALUE_POINTS});
                    this.products = array_products.sort(function(a, b) {return b.VALUE_POINTS - a.VALUE_POINTS});
                    this.searched_products = array_searched_products.sort(function(a, b) {return b.VALUE_POINTS - a.VALUE_POINTS});
                }

                this.changeSelectedFilter()
            },
            changeSelectedCategory(id) {
                this.searching = false;

                this.selectedCategory = this.category_data.filter((item) => (item.Id === id))[0].Id;
                this.changeSelectedFilter();
                this.products_filtered = this.products_filtered.filter((item) => (item.CATEGORY_ID == this.selectedCategory));

                this.getPageData(1)
            },

            getCatalogData(){
                // this.loading++
                axios.get(`/catalog-data`)
                    .then(({data}) => {
                        this.program_id = data.program_id
                        this.category_data = data.category_data
                        this.most_recent_products = data.most_recent_products
                        this.products = data.products

                        this.changeProductOrdering(this.productOrdering)
                        this.changeSelectedFilter()

                        // this.loading--
                    })
            },
            selectCategory(category, page = 1){
                this.selectedCategory = category;
                this.currentPage = page;
                this.searching = false;
                // this.loading++
                axios.get(`catalog-category/${this.selectedCategory}/load-data?page=${page}`)
                     .then(({data}) => {
                        this.products = data.products
                        this.pagination = data.pagination
                        this.lastPage = data.pagination.pages_numbers[data.pagination.pages_numbers.length - 1]
                        console.log(this.lastPage)
                        this.searching = false
                        this.searchKey = ""
                        // this.loading--
                        window.scrollTo(0, 0);
                        this.updateURL();
                        this.updateMiga(category);
                     })
            },
            searchProducts2(searchTerm) {
                this.searched_products = this.products.filter((item) => (item.NAME.toLowerCase().includes(searchTerm.toLowerCase()) || item.CATEGORY.toLowerCase().includes(searchTerm.toLowerCase())))
                this.changeProductOrdering(this.productOrdering)
                this.changeSelectedFilter()
            },
            redirect(url){
                window.location.href = url
            },
            slickOptionsProps(){
                this.slickOptionsProducts = {
                    dots: false,
                        arrows: false,
                        infinite: true,
                        centerMode: false,
                        autoplay: false,
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        responsive: [
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 1150,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 2,
                                infinite: true,
                                dots: false,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                dots: false,
                                arrows: false
                            }
                        }
                    ]
                }
                this.slickOptionsCategories = {
                    dots: false,
                        arrows: false,
                        infinite: false,
                        centerMode: false,
                        autoplay: false,
                        slidesToShow: 15,
                        slidesToScroll: 1,
                        responsive: [
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: 15,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 1150,
                            settings: {
                                slidesToShow: 10,
                                slidesToScroll: 5,
                                infinite: true,
                                dots: false,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 3,
                                infinite: true,
                                dots: false,
                                arrows: false
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 2,
                                dots: true,
                                arrows: false,
                                centerMode: false,
                                infinite: false,
                            }
                        }
                    ]
                }
            },
            clearSearch(){
                this.searching = false;
                this.selectedCategory = null;
                this.searchKey = "";
                this.updateURL();
            },
            //miga de pan y redirect
            updateMiga(category) {
                const nameCategory = this.categoryProducts.find(categoryData => categoryData.id_netcommerce === category);
                if (nameCategory) {
                    this.categoryName = nameCategory.name;
                }else{
                    this.categoryName = null;
                }
            },
            updateURL(outStanding = 0) {
                const queryParams = new URLSearchParams();
                let url = '';
                if (this.categorySelected !== 0 && outStanding === 0) {
                    queryParams.set('category', this.categorySelected);
                    this.show_banners = false;
                }
                if(outStanding === 1){
                    queryParams.set('category', 'outStanding');
                    this.show_banners = true;
                }
                if (this.pageSelected !== 1 ) {
                    queryParams.set('page', this.pageSelected);
                }
                if (this.productSearch !== '') {
                    queryParams.set('search_text',this.productSearch);
                    this.searching = true;
                }
                url += `?${queryParams.toString()}`;
                window.history.pushState({}, '', url);
            },
            // nuevo
            getCatalog(){
                this.loading = 1;
                this.alreadyAttemptedFallback = false;
                axios.get(`catalog-data`)
                    .then(({data}) => {
                        this.productSearch = '';
                        this.categoryProducts = data.categories
                        this.totalPoints = data.total_points
                        this.dataProducts = data.products
                        this.allProducts = this.dataProducts
                        this.dataProducts = this.availableProductsByPoints(this.dataProducts, this.totalPoints);
                        this.loading = 0;
                        this.applyOrderFilter();
                        if(this.selectedPointRanges && this.selectedPointRanges.length > 0){
                            this.applyFilters();
                        }
                    })
            },
            categorySelect(category){
                this.loading++;
                this.alreadyAttemptedFallback = false;
                this.categorySelected = category
                axios.get(`catalog-data?category=${this.categorySelected}`)
                    .then(({data}) => {
                        this.productSearch = '';
                        this.pageSelected = 1;
                        this.dataProducts = data.products;
                        this.allProducts = this.dataProducts
                        this.applyOrderFilter(this.dataProducts);
                        this.loading--;
                        if(this.selectedPointRanges && this.selectedPointRanges.length > 0){
                            this.applyFilters();
                            this.applyOrderFilter();
                        }
                        this.updateURL();
                        this.updateMiga(category);
                    })
            },
            availableProductsByPoints(productos, totalPoints){
                return productos.filter(producto => producto.value_points <= totalPoints);
            },
            searchProducts() {
                this.loading++;
                this.categorySelected = 0;
                this.alreadyAttemptedFallback = false;
                axios.get(`/catalog-data?search=${this.productSearch}`)
                    .then(({ data }) => {
                        this.dataProducts = data.products;
                        this.allProducts = this.dataProducts
                        this.applyOrderFilter();
                        if(this.selectedPointRanges && this.selectedPointRanges.length > 0){
                            this.applyFilters();
                        }
                        this.loading--;
                        this.updateURL();
                        this.updateMiga(0);
                    })
            },
            prevPage() {
                if (this.pageSelected > 1) {
                    this.pageSelected--;
                }
                this.updateURL();
            },
            nextPage() {
                if (this.pageSelected < this.pagesTotals) {
                    this.pageSelected++;
                }
                this.updateURL();
            },
            goToPage(page) {
                if (page >= 1 && page <= this.pagesTotals) {
                    this.pageSelected = page;
                }
                this.updateURL();
            },
            applyOrderFilter() {
                // this.loading++
                switch (this.orderFilterOption) {
                    case 1:
                        // this.loading--;
                        this.dataProductsOrder = [...this.dataProducts.map(productData => {
                            productData.name = productData.name.trim()
                            return productData
                        })];
                        this.dataProductsOrder.sort((a, b) => a.name.localeCompare(b.name));
                        this.dataProducts = this.dataProductsOrder;
                        break;
                    case 2:
                        // this.loading--;
                        this.dataProductsOrder = [...this.dataProducts];
                        this.dataProductsOrder.sort((a, b) => a.value_points - b.value_points);
                        this.dataProducts = this.dataProductsOrder;
                        break;
                    case 3:
                        // this.loading--;
                        this.dataProductsOrder = [...this.dataProducts];
                        this.dataProductsOrder.sort((a, b) => b.value_points - a.value_points);
                        this.dataProducts = this.dataProductsOrder;
                        break;
                }
            },
            changeOrderFilter(order) {
                this.orderFilterOption = order;
                this.orderModal = false;
                this.applyOrderFilter();
            },
            selectPointRange(rangeValue) {
                this.addPointRangeFilter(rangeValue);
                this.orderPointsModal = false; // Cierra el modal después de la selección.
            },
            addPointRangeFilter(rangeValue) {
                const range = this.availablePointRanges.find(r => r.value === rangeValue);
                if (!this.selectedPointRanges.includes(range)) {
                    this.selectedPointRanges.push(range);
                    this.applyFilters();
                    this.applyOrderFilter();
                }
            },
            removePointRangeFilter(index) {
                this.selectedPointRanges.splice(index, 1);
                // this.applyFilters();
                if (this.selectedPointRanges && this.selectedPointRanges.length == 0) {
                    this.orderFilterPointsOption = null;
                    if (this.categorySelected != 0 && this.categorySelected != null) {
                        this.categorySelect(this.categorySelected);
                    } else if (this.categorySelected == null) {
                        this.categoriadestacada()
                    } else if (this.productSearch) {
                        this.searchProducts();
                    } else if (this.categorySelected == 0 && !this.productSearch) {
                        this.getCatalog();
                        this.dataProducts = this.availableProductsByPoints(this.dataProducts, this.totalPoints);
                    }
                } else {
                    this.applyFilters();
                    this.applyOrderFilter();
                }
            },
            applyFilters() {
            // Inicio del filtrado
                this.filteredProducts = [];
                const totalRange = this.selectedPointRanges.reduce((acc, range) => {
                    acc.min = Math.min(acc.min, range.min);
                    acc.max = Math.max(acc.max, range.max);
                    return acc;
                }, { min: Infinity, max: -Infinity });

                this.filteredProducts = this.allProducts.filter(product => {
                    return product.value_points >= totalRange.min && product.value_points <= totalRange.max;
                });

                this.pageSelected = 1
                this.updateURL()

                this.dataProducts = this.filteredProducts;
            },
            categoriadestacada(){
                this.loading++;
                this.categorySelected = null;
                axios.get(`catalog-data`)
                    .then(({data}) => {
                        this.pageSelected = 1;
                        this.categoryProducts = data.categories
                        this.dataProducts = data.products
                        this.allProducts = this.dataProducts
                        this.loading--;
                        this.dataProducts = this.dataProducts.filter(producto => producto.outstanding === 1);
                        this.applyOrderFilter();
                        if(this.selectedPointRanges && this.selectedPointRanges.length > 0){
                            this.applyFilters();
                        }
                        this.updateURL(1);
                        this.updateMiga(this.categorySelected);
                    })
            }
        },
    }
</script>
